export default {
  getterListProvince: state => state.listProvinces,
  getterListDistrict: state => state.listDistricts,
  getterListWard: state => state.listWards,
}
